module.exports = __webpack_public_path__ + "src/img/zalando/tabbar.ef138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/tabbar.jpg
// module id = 273
// module chunks = 0